﻿import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

export const BrightTooltip = withStyles({
  tooltipPlacementTop: {
    margin: '4px',
  },
  tooltip: {
    backgroundColor: '#ffffff !important',
    color: '#000000 !important',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.12)',
    borderRadius: '2px',
    fontSize: '14px !important',
  },
})(Tooltip);
